export enum StyleCommand {
  Bold = 'bold',
  Italic = 'italic',
  Underline = 'underline',
}
